import { SxProps } from "@mui/material";
import { useEffect, useState } from "react";
import { ActionItemStatusChangedDialogContent, StatusPicker, useDialog } from "src/components";
import {
  ACTION_ITEM_STATUSES,
  ActionItemStatus,
  ClosedActionItemStatuses,
  DEFAULT_ACTION_ITEM_STATUS,
} from "src/constants";
import { useEditActionItemStatus } from "src/http";

interface IProps {
  actionItemGuid: string;
  status: ActionItemStatus;
  planGuid: string;
  variant: "button" | "select";
  disabled?: boolean;
  sx?: SxProps;
}

const ActionItemStatusPicker = (props: IProps) => {
  const [selectedStatus, setSelectedStatus] = useState<ActionItemStatus>(props.status ?? DEFAULT_ACTION_ITEM_STATUS);
  const { mutate: editActionItemStatus } = useEditActionItemStatus();
  const { showDialog, closeDialog } = useDialog();

  useEffect(() => {
    setSelectedStatus(props.status ?? DEFAULT_ACTION_ITEM_STATUS);
  }, [props.status]);

  function handleStatusChanged(newSelectedStatus: ActionItemStatus) {
    setSelectedStatus(newSelectedStatus);

    if (newSelectedStatus !== ActionItemStatus.Open) {
      showDialog({
        content: (
          <ActionItemStatusChangedDialogContent
            actionItemGuid={props.actionItemGuid}
            status={newSelectedStatus}
            onDone={closeDialog}
            onCancel={closeDialog}
          />
        ),
      });
    }

    editActionItemStatus({
      actionItemGuid: props.actionItemGuid,
      statusId: newSelectedStatus,
      planGuid: props.planGuid,
    });
  }

  return (
    <StatusPicker
      variant={props.variant}
      disabled={props.disabled}
      value={selectedStatus}
      options={ACTION_ITEM_STATUSES.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : 0))}
      groupBy={(option) => (ClosedActionItemStatuses.includes(option.id) ? "Closed Statuses" : "Active Statuses")}
      onChange={handleStatusChanged}
      sx={{ ...props.sx }}
    />
  );
};

export { ActionItemStatusPicker };
